import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
export const App = () => {
  return (
    <>
      <div className={classNames('page-wrapper')}>
        <div className="page-header d-print-none">
          <div className="container-xl">
            <div className="row g-2 align-items-center">
              <div className="col">
                <div className="placeholder col-9"></div>
                <div className="placeholder placeholder-xs col-5"></div>
              </div>
              <a
                href="#"
                tabIndex={-1}
                className="btn btn-primary disabled placeholder col-2"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="container-xl">
            <div className="row row-cards">
              <div className="col-12">
                <div className="card placeholder-glow">
                  <div className="card-body">
                    <div className="placeholder col-9 mb-3" />
                    <div className="ratio ratio-21x9 card-img-top placeholder" />
                    <div className="mt-3">
                      <a
                        href="#"
                        tabIndex={-1}
                        className="btn btn-primary disabled placeholder col-4"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
